import { createActionType } from "Common/namespaceUtils/namespaceRedux";
import { FULL_NAMESPACE } from "../constants";
export default {
    GET_USER_STATUS_DICTIONARY: createActionType(FULL_NAMESPACE, "GET_USER_STATUS_DICTIONARY"),
    GET_USER_STATUS_DICTIONARY_COMPLETED: createActionType(FULL_NAMESPACE, "GET_USER_STATUS_DICTIONARY_COMPLETED"),
    GET_USER_STATUS_DICTIONARY_REJECTED: createActionType(FULL_NAMESPACE, "GET_USER_STATUS_DICTIONARY_REJECTED"),
    GET_SELF: createActionType(FULL_NAMESPACE, "GET_SELF"),
    GET_SELF_COMPLETED: createActionType(FULL_NAMESPACE, "GET_SELF_COMPLETED"),
    GET_USERS: createActionType(FULL_NAMESPACE, "GET_USERS"),
    GET_USERS_COMPLETED: createActionType(FULL_NAMESPACE, "GET_USERS_COMPLETED"),
    BLOCK_USERS: createActionType(FULL_NAMESPACE, "BLOCK_USERS"),
    BLOCK_USERS_COMPLETED: createActionType(FULL_NAMESPACE, "BLOCK_USERS_COMPLETED"),
    UNBLOCK_USERS: createActionType(FULL_NAMESPACE, "UNBLOCK_USERS"),
    UNBLOCK_USERS_COMPLETED: createActionType(FULL_NAMESPACE, "UNBLOCK_USERS_COMPLETED"),
    REMOVE_USERS: createActionType(FULL_NAMESPACE, "REMOVE_USERS"),
    REMOVE_USERS_COMPLETED: createActionType(FULL_NAMESPACE, "REMOVE_USERS_COMPLETED"),
    SAVE_USER: createActionType(FULL_NAMESPACE, "SAVE_USER"),
    SAVE_USER_COMPLETED: createActionType(FULL_NAMESPACE, "SAVE_USER_COMPLETED")
};
